var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_DataView.js
// module id = 821
// module chunks = 0 1 2 3 4 5 6 7 8